/**
 * abilityVfxLulu — Lulu Q/W/E/R pix silhouettes (SPY-312).
 */

function mat(THREE, color, opacity = 0.9) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: opacity < 1,
    opacity,
    side: THREE.DoubleSide
  });
}

export function buildGlitterlance(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1);
  const pink = mat(THREE, spec.color || 0xf0abfc);
  const mint = mat(THREE, 0xa7f3d0);
  const bolt = new THREE.Mesh(new THREE.CylinderGeometry(0.05 * s, 0.08 * s, 1.15 * s, 8), pink);
  bolt.rotation.x = Math.PI / 2;
  bolt.position.y = 0.45 * s;
  group.add(bolt);
  const tip = new THREE.Mesh(new THREE.ConeGeometry(0.12 * s, 0.32 * s, 6), mint);
  tip.position.set(0, 0.45 * s, 0.7 * s);
  tip.rotation.x = Math.PI / 2;
  group.add(tip);
  const spark = new THREE.Mesh(new THREE.SphereGeometry(0.12 * s, 8, 8), mint);
  spark.position.set(0, 0.55 * s, -0.45 * s);
  group.add(spark);
  group.userData = { shape: 'glitterlance' };
  return group;
}

export function buildWhimsy(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.65 * (spec.scale || 1.3);
  const pink = mat(THREE, spec.color || 0xe879f9, 0.85);
  const mint = mat(THREE, 0x6ee7b7, 0.8);
  const core = new THREE.Mesh(new THREE.SphereGeometry(0.3 * s, 10, 10), pink);
  core.position.y = 0.55 * s;
  group.add(core);
  const halo = new THREE.Mesh(new THREE.TorusGeometry(0.4 * s, 0.05 * s, 8, 16), mint);
  halo.rotation.x = Math.PI / 2;
  halo.position.y = 0.55 * s;
  group.add(halo);
  const pix = new THREE.Mesh(new THREE.SphereGeometry(0.1 * s, 8, 8), mint);
  pix.position.set(0.38 * s, 0.85 * s, 0);
  group.add(pix);
  group.userData = { shape: 'whimsy' };
  return group;
}

export function buildHelpPix(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.6 * (spec.scale || 1.2);
  const mint = mat(THREE, spec.color || 0x34d399, 0.88);
  const pink = mat(THREE, 0xf5d0fe, 0.8);
  const pix = new THREE.Mesh(new THREE.SphereGeometry(0.22 * s, 10, 10), mint);
  pix.position.y = 0.7 * s;
  group.add(pix);
  const wing = new THREE.Mesh(new THREE.ConeGeometry(0.12 * s, 0.35 * s, 6), pink);
  wing.position.set(0.22 * s, 0.7 * s, 0);
  group.add(wing);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.2 * s, 0.45 * s, 16).rotateX(-Math.PI / 2),
    mint
  );
  ring.position.y = 0.08;
  group.add(ring);
  group.userData = { shape: 'help_pix' };
  return group;
}

export function buildWildGrowth(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.85 * (spec.scale || 1.7);
  const green = mat(THREE, spec.color || 0x22c55e, 0.88);
  const leaf = mat(THREE, 0x86efac, 0.8);
  const trunk = new THREE.Mesh(new THREE.CylinderGeometry(0.18 * s, 0.28 * s, 1.1 * s, 10), green);
  trunk.position.y = 0.6 * s;
  group.add(trunk);
  const canopy = new THREE.Mesh(new THREE.SphereGeometry(0.45 * s, 12, 10), leaf);
  canopy.position.y = 1.2 * s;
  group.add(canopy);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.35 * s, 0.8 * s, 20).rotateX(-Math.PI / 2),
    green
  );
  ring.position.y = 0.05;
  group.add(ring);
  group.userData = { shape: 'wild_growth' };
  return group;
}
